import { Web3Provider } from '@ethersproject/providers'
import { ChainId } from 'symbiosis-js-sdk'

import { ChainConfig } from '~/types/config'

export enum WalletType {
	NONE = null,
	METAMASK = 1,
	TRUST = 2,
	COIN98 = 3,
	XDEFI = 4,
	WALLET_CONNECT = 5,
	ONTO = 6,
	IM_TOKEN = 7,
	BITKEEP = 8,
	BLOCKCHAIN_COM = 9,
	OPERA = 10,
	SAFE_PAL = 11,
	KUCOIN = 12,
}

export enum WalletStatus {
	CONNECTING,
	CONNECTED,
	DISCONNECTED,
}

export type WalletState = {
	web3: Web3Provider
	status: WalletStatus
	walletType: WalletType
	account: Address
	chainId: ChainId
}

export type WalletMethods = {
	connect: (walletType?: WalletType) => Promise<void>
	disconnect: () => Promise<void>
	setChain: (chainId: ChainId) => Promise<void>
	canSetChain: () => boolean
	addChain: (chainConfig: ChainConfig) => Promise<void>
	isCurrentChain: (chainId: ChainId) => boolean
}

export type WalletHook = WalletState & WalletMethods

export type Action =
	| { type: 'connecting' }
	| {
			type: 'connect'
			account: Address
			chainId: ChainId
			web3: Web3Provider
			walletType: WalletType
	  }
	| { type: 'disconnect' }
	| { type: 'account'; account: Address }
	| { type: 'chainChanged'; chainId: ChainId }
